/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { db_DropdownPlacementStatus } from '../models/db_DropdownPlacementStatus';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PlacementStatuses {
    /**
     * Get a list of placement statuses
     * @returns db_DropdownPlacementStatus OK
     * @throws ApiError
     */
    public static listPlacementStatuses(): CancelablePromise<Array<db_DropdownPlacementStatus>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/placement-statuses',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
